module.exports = __webpack_public_path__ + "img/arms_3_1.9085bb7e.png";